module.exports = __webpack_public_path__ + "media/main_video.b37fedec.mp4";